// ag-grid locale text for Swedish (sv)
// this is used in the ag-grid-vue component via the localeText prop

export default {
    // Set Filter
    selectAll: '(Markera alla)',
    selectAllSearchResults: '(Markera alla sökresultat)',
    searchOoo: 'Sök...',
    blanks: '(Tomma)',
    noMatches: 'Inga träffar',

    // Number Filter & Text Filter
    filterOoo: 'Filtrera...',
    equals: 'Lika med',
    notEqual: 'Inte lika med',
    empty: 'Välj ett',

    // Number Filter
    lessThan: 'Mindre än',
    greaterThan: 'Större än',
    lessThanOrEqual: 'Mindre än eller lika med',
    greaterThanOrEqual: 'Större än eller lika med',
    inRange: 'Inom intervallet',
    inRangeStart: 'till',
    inRangeEnd: 'från',

    // Text Filter
    contains: 'Innehåller',
    notContains: 'Innehåller inte',
    startsWith: 'Börjar med',
    endsWith: 'Slutar med',

    // Date Filter
    dateFormatOoo: 'åååå-mm-dd',

    // Filter Conditions
    andCondition: 'OCH',
    orCondition: 'ELLER',

    // Filter Buttons
    applyFilter: 'Tillämpa',
    resetFilter: 'Återställ',
    clearFilter: 'Rensa',
    cancelFilter: 'Avbryt',

    // Filter Titles
    textFilter: 'Textfilter',
    numberFilter: 'Talfilter',
    dateFilter: 'Datumfilter',
    setFilter: 'Uppsättningsfilter',

    // Side Bar
    columns: 'Kolumner',
    filters: 'Filter',

    // columns tool panel
    pivotMode: 'Pivotläge',
    groups: 'Radgrupper',
    rowGroupColumnsEmptyMessage: 'Dra hit för att skapa radgrupper',
    values: 'Värden',
    valueColumnsEmptyMessage: 'Dra hit för att aggregera',
    pivots: 'Kolumnetiketter',
    pivotColumnsEmptyMessage: 'Dra hit för att skapa kolumnetiketter',

    // Header of the Default Group Column
    group: 'Grupp',

    // Other
    loadingOoo: 'Laddar...',
    noRowsToShow: 'Inga rader att visa',
    enabled: 'Aktiverad',

    // Menu
    pinColumn: 'Fäst kolumn',
    pinLeft: 'Fäst till vänster',
    pinRight: 'Fäst till höger',
    noPin: 'Fäst inte',
    valueAggregation: 'Värdeaggregering',
    autosizeThiscolumn: 'Autoanpassa denna kolumn',
    autosizeAllColumns: 'Autoanpassa alla kolumner',
    groupBy: 'Gruppera efter',
    ungroupBy: 'Avgruppera efter',
    resetColumns: 'Återställ kolumner',
    expandAll: 'Expandera alla',
    collapseAll: 'Fäll ihop alla',
    copy: 'Kopiera',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Kopiera med rubriker',
    paste: 'Klistra in',
    ctrlV: 'Ctrl+V',
    export: 'Exportera',
    csvExport: 'CSV-export',
    excelExport: 'Excel-export',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Summa',
    min: 'Min',
    max: 'Max',
    none: 'Ingen',
    count: 'Antal',
    avg: 'Medelvärde',
    filteredRows: 'Filtrerade',
    selectedRows: 'Markerade',
    totalRows: 'Totalt antal rader',
    totalAndFilteredRows: 'Rader',
    more: 'Mer',
    to: 'till',
    of: 'av',
    page: 'Sida',
    nextPage: 'Nästa sida',
    lastPage: 'Sista sidan',
    firstPage: 'Första sidan',
    previousPage: 'Föregående sida',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivotdiagram och pivotläge',
    pivotChart: 'Pivotdiagram',
    chartRange: 'Diagramintervall',

    columnChart: 'Kolumn',
    groupedColumn: 'Grupperad',
    stackedColumn: 'Staplad',
    normalizedColumn: '100 % staplad',

    barChart: 'Stapel',
    groupedBar: 'Grupperad',
    stackedBar: 'Staplad',
    normalizedBar: '100 % staplad',

    pieChart: 'Cirkeldiagram',
    pie: 'Cirkeldiagram',
    doughnut: 'Ring',

    line: 'Linje',

    xyChart: 'X Y (Spridning)',
    scatter: 'Spridning',
    bubble: 'Bubbla',

    areaChart: 'Yta',
    area: 'Yta',
    stackedArea: 'Staplad',
    normalizedArea: '100 % staplad',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivotdiagram',
    rangeChartTitle: 'Intervalldiagram',
    settings: 'Inställningar',
    data: 'Data',
    format: 'Format',
    categories: 'Kategorier',
    defaultCategory: '(Ingen)',
    series: 'Serier',
    xyValues: 'X Y-värden',
    paired: 'Parat läge',
    axis: 'Axel',
    navigator: 'Navigator',
    color: 'Färg',
    thickness: 'Tjocklek',
    xType: 'X-typ',
    automatic: 'Automatisk',
    category: 'Kategori',
    number: 'Tal',
    time: 'Tid',
    xRotation: 'X-rotation',
    yRotation: 'Y-rotation',
    ticks: 'Skalstreck',
    width: 'Bredd',
    height: 'Höjd',
    length: 'Längd',
    padding: 'Utfyllnad',
    spacing: 'Mellanrum',
    chart: 'Diagram',
    title: 'Titel',
    titlePlaceholder: 'Diagramtitel - dubbelklicka för att redigera',
    background: 'Bakgrund',
    font: 'Typsnitt',
    top: 'Överkant',
    right: 'Höger',
    bottom: 'Nederkant',
    left: 'Vänster',
    labels: 'Etiketter',
    size: 'Storlek',
    minSize: 'Minsta storlek',
    maxSize: 'Största storlek',
    legend: 'Teckenförklaring',
    position: 'Position',
    markerSize: 'Markörstorlek',
    markerStroke: 'Markörkontur',
    markerPadding: 'Markörutfyllnad',
    itemSpacing: 'Objektavstånd',
    itemPaddingX: 'Objektutfyllnad X',
    itemPaddingY: 'Objektutfyllnad Y',
    layoutHorizontalSpacing: 'Horisontellt avstånd',
    layoutVerticalSpacing: 'Vertikalt avstånd',
    strokeWidth: 'Konturbredd',
    offset: 'Förskjutning',
    offsets: 'Förskjutningar',
    tooltips: 'Verktygstips',
    callout: 'Utropstext',
    markers: 'Markörer',
    shadow: 'Skugga',
    blur: 'Oskärpa',
    xOffset: 'X-förskjutning',
    yOffset: 'Y-förskjutning',
    lineWidth: 'Linjebredd',
    normal: 'Normal',
    bold: 'Fet',
    italic: 'Kursiv',
    boldItalic: 'Fet kursiv',
    predefined: 'Fördefinierad',
    fillOpacity: 'Fyllningsopacitet',
    strokeOpacity: 'Linjeopacitet',
    histogramBinCount: 'Antal intervall',
    columnGroup: 'Kolumn',
    barGroup: 'Stapel',
    pieGroup: 'Cirkeldiagram',
    lineGroup: 'Linje',
    scatterGroup: 'X Y (Spridning)',
    areaGroup: 'Yta',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grupperad',
    stackedColumnTooltip: 'Staplad',
    normalizedColumnTooltip: '100 % staplad',
    groupedBarTooltip: 'Grupperad',
    stackedBarTooltip: 'Staplad',
    normalizedBarTooltip: '100 % staplad',
    pieTooltip: 'Cirkeldiagram',
    doughnutTooltip: 'Ring',
    lineTooltip: 'Linje',
    groupedAreaTooltip: 'Yta',
    stackedAreaTooltip: 'Staplad',
    normalizedAreaTooltip: '100 % staplad',
    scatterTooltip: 'Spridning',
    bubbleTooltip: 'Bubbla',
    histogramTooltip: 'Histogram',
    noDataToChart: 'Ingen data tillgänglig att visa i diagram.',
    pivotChartRequiresPivotMode: 'Pivotdiagram kräver att pivotläge är aktiverat.',
    chartSettingsToolbarTooltip: 'Meny',
    chartLinkToolbarTooltip: 'Länkad till rutnätet',
    chartUnlinkToolbarTooltip: 'Olänkad från rutnätet',
    chartDownloadToolbarTooltip: 'Ladda ner diagram',

    // ARIA
    ariaHidden: 'dold',
    ariaVisible: 'synlig',
    ariaChecked: 'markerad',
    ariaUnchecked: 'omarkerad',
    ariaIndeterminate:'obestämd',
    ariaColumnSelectAll: 'Växla markering av alla kolumner',
    ariaInputEditor: 'Inmatningsredigerare',
    ariaDateFilterInput: 'Inmatning för datumfilter',
    ariaFilterInput: 'Filterinmatning',
    ariaFilterColumnsInput: 'Inmatning för kolumnfilter',
    ariaFilterValue: 'Filtervärde',
    ariaFilterFromValue: 'Filtrera från värde',
    ariaFilterToValue: 'Filtrera till värde',
    ariaFilteringOperator: 'Filtreringsoperator',
    ariaColumnToggleVisibility: 'växla kolumnens synlighet',
    ariaColumnGroupToggleVisibility: 'växla kolumngruppens synlighet',
    ariaRowSelect: 'Tryck på MELLANSLAG för att markera denna rad',
    ariaRowDeselect: 'Tryck på MELLANSLAG för att avmarkera denna rad',
    ariaRowToggleSelection: 'Tryck på mellanslag för att växla radmarkering',
    ariaRowSelectAll: 'Tryck på mellanslag för att växla markering av alla rader',
    ariaSearch: 'Sök',
    ariaSearchFilterValues: 'Sök filtervärden'
}